import classNames from "classnames";
import React, { memo } from "react";
import Styled from "./totalInfoArea.styled";
function TotalInfoArea(props) {
    return (React.createElement(Styled.Container, { blockWidth: props.width, blockHeight: props.height, bgColor: props.bgColor, borderColor: props.borderColor, className: classNames("p-1 v-start-items", props.className) },
        React.createElement(Styled.Icon, { color: props.iconColor, className: classNames(props.icon, "font-h5") }),
        React.createElement("div", { className: "ml-0_75 overflow-hidden" },
            React.createElement("h3", { className: "font-bold text-overflow-ellipsis", title: props.title }, props.title),
            props.description && (React.createElement("div", { className: "text-overflow-ellipsis text-muted nowrap font-h6", title: props.description }, props.description)))));
}
export default memo(TotalInfoArea);
TotalInfoArea.defaultProps = {
    height: 70
};
